export default "__VITE_ASSET__BobBIrzy__"